import { yupResolver } from '@hookform/resolvers/yup'
import { Spinner } from 'components/common'
import UserForm from 'components/userManagement/userForm'
import { formatObjectWithPageAccess } from 'components/userManagement/utils'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'
import { User } from 'types/user'
import { getUser, updateUser } from 'utils/api/userManagement'
import { ERROR_CODES, PAGE_NOT_FOUND, PAGE_USER_MGMT } from 'utils/constants'
import { handleError } from 'utils/helpers/handleError'
import { updateUserSchema, UpdateUserType } from 'utils/schema/authSchema'

const UpdateUser = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [userData, setUserData] = useState<User>()
  const [loading, setLoading] = useState<boolean>(false)

  const form = useForm<UpdateUserType>({
    resolver: yupResolver(updateUserSchema),
  })

  //To fetch user data using id
  const getUserData = async (id: string) => {
    setLoading(true)
    try {
      const { data } = await getUser(id)
      form.reset(data)
      setUserData(data)
    } catch (error) {
      navigate(PAGE_NOT_FOUND.path)
    } finally {
      setLoading(false)
    }
  }

  // To initially fetch user data if id is present
  useEffect(() => {
    if (id) {
      getUserData(id)
    }
  }, [])

  // to handle submit form
  const handleUpdateUser = async (userData: Record<string, unknown>) => {
    const formData = formatObjectWithPageAccess(userData)

    const loader = toast.loading('Updating user...')
    try {
      if (id) {
        // deleting non Editable fields
        delete formData.email
        delete formData.empId

        await updateUser({ id, data: formData })
        toast.success('User updated successfully', { id: loader })

        navigate(PAGE_USER_MGMT.path)
      }
    } catch (error) {
      handleError(error, loader, {
        default: 'Failed to create user',
        [ERROR_CODES.EMAIL_ALREADY_EXISTS]: 'Email already exist',
      })
    }
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Update User </title>
      </Helmet>

      <UserForm
        submitButtonText="Update"
        submitHandler={handleUpdateUser}
        defaultUser={userData}
        hookForm={form}
        isUpdatePage
      />
    </>
  )
}

export default UpdateUser
